import { Component, OnInit, OnDestroy } from '@angular/core';

// ionic
import { ModalController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";

// ionic native
import { Keyboard, KeyboardResizeMode } from '@awesome-cordova-plugins/keyboard/ngx';

// services
import { AgendaService } from "../../services/agenda.service";
import { PlatformService } from '../../services/platform.service';
import { OverlayService } from "../../services/overlay.service";

// models
import { SpeakerQuestion } from "../../models/speaker-question";

// config not using...
import { environment } from "../../../environments/environment";

@Component({
    selector: 'app-new-question',
    templateUrl: './new-question.component.html',
    styleUrls: ['./new-question.component.scss'],
})
export class NewQuestionComponent implements OnInit, OnDestroy {

    // question;
    presentation;
    speaker;
    question: SpeakerQuestion = new SpeakerQuestion;
    // maxLength = 180;
    showSpeakerDetail;

    /**
     * validate state
     *
     * @type {boolean}
     */
    public validate: boolean = false;

    /**
     * Validation errors
     *
     * @type {object}
     */
    public validationErrors: object = {};

    /**
     * validation errors state
     *
     * @type {boolean}
     */
    public hasValidationErrors: boolean = false;

    public submit: boolean = false;

    /**
     * env configuration
     */
    public env = environment;

    constructor(
        public plt: PlatformService,
        public modalController: ModalController,
        public overlayService: OverlayService,
        public translate: TranslateService,
        private agendaService: AgendaService,
        private keyboard: Keyboard,
    ) {
        if (this.plt.is('cordova')) {
            this.keyboard.setResizeMode(KeyboardResizeMode.Body); 
        }
    }

    ngOnInit() {
    }

    close() {
        this.modalController.dismiss({ action: 'close' });
    }

    /**
     * process form, validate note
     */
    sendQuestion(valid) {
        this.submit = true;
        this.validate = true;
        this.validationErrors = {};

        if (valid) {
            this.question.agenda_speaker_id = this.speaker.id;

            this.agendaService.createQuestion(this.presentation.event_id, this.question).subscribe(
                (success) => {
                    this.speaker.agenda = this.presentation;
                    this.question.agenda_speaker = this.speaker;

                    this.validate = false;
                    this.submit = false;

                    this.modalController.dismiss({
                        question: success.question,
                        success: success.message,
                        action: 'close'
                    });
                },
                (error) => {
                    this.handleError(error);
                }
            );
        }
    }

    private handleError(response) {
        const data = response.error;

        if (data.fields) {
            for (const field in data.fields) {
                if (data.fields.hasOwnProperty(field)) {
                    this.hasValidationErrors = true;
                    this.validationErrors[field] = data.fields[field].join(' ');
                }
            }
        }

        this.submit = false;
        this.overlayService.showError(data.message);
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        if (this.plt.is('cordova')) {
            this.keyboard.setResizeMode(KeyboardResizeMode.Native); 
        }
    }
}
